<ng-container *ngIf="column.template" [ngTemplateOutlet]="column.template" [ngTemplateOutletContext]="{row: row, grid: grid}"></ng-container>
<ng-container *ngIf="!column.template" [class]="getClass()">
    <i *ngIf="hasIcon()" [class]="getIcon()"></i>{{getColumnText()}}
</ng-container>
<span *ngIf="toggleable" class="d-block text-center">
    <i [class]="getExpandIcon()" [id]="grid?.getId('_' + index + '_' + row.id) + '_expand'" role="button" (click)="onExpand($event)"></i>
</span>